import {IQuery, TRouteFn} from 'core/modules/routing/types';
import {useRouter} from 'next/router';
import {useCallback} from 'react';

const useRouteRedirect = () => {
    const {push} = useRouter();

    return useCallback(
        (fn: TRouteFn) => (query?: IQuery) => {
            const url = fn(query);
            push?.(url);
        },
        [push],
    );
};

export default useRouteRedirect;
